<div style="margin-left: 20px;margin-top: 60px;">
    <h2>Privacy Policy</h2>
    <h5 style="margin-top: 40px;">Introduction</h5>
</div>
<div style="margin-left: 20px;margin-top: 20px;">
  
            <p>
                ("Apptunix") having its registered office at 3rd Floor, C-127, Phase-8, Industrial Area, Sector 73,
                Sahibzada Ajit Singh Nagar, Punjab 160071

                This Privacy Policy is a part of the Terms and Conditions and all terms defined in the Terms and
                Conditions have the same meaning used here in this Privacy Policy.

                This Privacy Policy statement shall apply to all users who visit and access Apptunix website and
                mobile application (collectively referred to as "Website"). The users unconditionally agree that
                browsing the Website and/or using its services signifies their unconditional assent to this Privacy
                Policy.

                Apptunix/we respect the privacy of it's users and is committed to protect it in all respects. Any
                dispute with Apptunix over privacy matters are subject to this Privacy Policy read in conjunction with
                the Terms and Conditions. matters are subject to this Privacy Policy read in conjunction with the Terms
                and Conditions.
            </p>
       
</div>